import React, { useState, useEffect } from 'react';
import { Container, Label, Input, Modal, ModalHeader, ModalBody } from 'reactstrap';
import '../../share/form.css';
import { Formik, Field, Form, FieldArray, ErrorMessage } from 'formik';
import CreateTableComponent from "../../share/CreateTableComponent";
import { useNavigate, useSearchParams } from 'react-router-dom';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import * as Yup from 'yup'
import { BsPlusLg } from "react-icons/bs";
import { Loading } from '../../share/loading'
import { AiOutlineDelete } from "react-icons/ai";
import TextErrors from "../../share/TextErrors";
import '../../share/TabStyle.css'
import "../../share/form.css";
import "../../share/DatePickerInputStyle.css"
import "../../share/ModalReactStrapStyle.css"
import { FiEdit3 } from "react-icons/fi";
import '../../share/form.css';
import Swal from 'sweetalert2';

export function JobPositionFormTestComponent() {
    let rootColorErrors = "#d33";
    let rootColorPrimary = "#0A66C2";
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const user = JSON.parse(localStorage.getItem("userData"));
    const [cansubmit, setCanSubmit] = useState(false);
    const [courseSelect, setCourseSelect] = useState([]);
    const [tabIndex, setTabIndex] = useState(0);
    const [detailJobPositionDataAr, setDetailJobPositionDataAr] = useState([]);
    const [loading, setLoading] = useState(false);
    const [openModalForm, setOpenModalForm] = useState(false);
    const Toggle = () => setOpenModalForm(!openModalForm);

    useEffect(() => {
        ListTrainTestJobposition()
        getTestJobposition()
    }, [])

    function checkPreviousPage() {
        return navigate(`/borrowing/BorrowForm/attatchFileTest?req=${searchParams.get("req")}&train=${searchParams.get("train")}&test=${searchParams.get("test")}&status=${searchParams.get("status")}`)
    }

    useEffect(() => {
        async function checkCanSubmit() {
            let check = [];
            await courseSelect.forEach((test) => {
                test.listTestTimes.forEach((time) => {
                    time.employeeAmount === time.personAmount ? check.push(true) : check.push(false)
                })
            })
            check.every(x => x === true) ? setCanSubmit(true) : setCanSubmit(false)
        }
        checkCanSubmit()
    }, [courseSelect])

    async function getTestJobposition() {
        setLoading(true)
        let postData = new FormData();
        postData.append("borrowId", searchParams.get("req"))
        try {
            let res = await fetch("/api/BorrowRegis/getTrainTestJobposition", {
                method: "POST",
                body: postData
            });
            const resJson = await res.json()
            setDetailJobPositionDataAr(
                resJson.dataenum.filter(item => item.testJobpositionName != null)
            );
        } catch (e) {
            console.log(e)
        } finally {
            setLoading(false)
        }
    }

    async function ListTrainTestJobposition() {
        setLoading(true)
        try {
            let res = await fetch("/api/BorrowRegis/listTrainTestJobposition", {
                method: "POST",
                headers: { "Content-type": "application/json" },
                body: JSON.stringify({
                    "BorrowId": searchParams.get("req")
                }),
            });
            const resJson = await res.json()
            setCourseSelect(
                resJson.dataenum.filter(item => item.testId != null)
            );
        } catch (err) {
            console.log("err =>" + err)
        } finally {
            setLoading(false)
        }
    }

    const onSubmit = async (values) => {
        let postData = new FormData();
        postData.append("borrowId", values.borrowId)
        Swal.fire({
            icon: "info",
            title: "ยืนยันการส่งคำขอกู้ยืมเงินหรือไม่?",
            confirmButtonColor: rootColorPrimary,
            confirmButtonText: "ยันยัน",
            cancelButtonText: 'ยกเลิก',
            cancelButtonColor: '#d33',
            showCancelButton: true,
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    let res = await fetch("/api/BorrowRegis/confirmBorrow", {
                        method: "POST",
                        body: postData
                    });
                    let resJson = await res.json();
                    if (resJson.status === 1) {
                        Swal.fire({
                            icon: "success",
                            title: "บันทึกข้อมูลสำเร็จ",
                            text: "โปรดรอเจ้าหน้าที่ตรวจสอบ",
                            confirmButtonColor: "#0A66C2",
                        }).then(() => navigate("/borrowing/"));
                    } else {
                        Swal.fire({
                            icon: "error",
                            title: "บันทึกข้อมูลไม่สำเร็จ",
                            text: `เนื่องจาก ${resJson.message}`,
                            confirmButtonColor: "#0A66C2",
                        });
                    }
                } catch (e) {
                    console.log(e)
                }
            }
        })
    }

    const initialValues = {
        borrowId: searchParams.get("req"),
    }

    // -------------------- VALIDATION --------------------
    const detailJobpositionValidationSchema = Yup.object().shape({
        testJobpositionName: Yup.string().required("กรุณากรอกชื่อตำแหน่งงาน"),
        personTotal: Yup.number()
            .typeError("กรุณากรอกตัวเลข")
            .positive("จำนวนพนักงานต้องมากกว่า 0")
            .required("กรุณากรอกจำนวนพนักงาน"),
            // .test(
            //     "sum-personAmount-not-exceed",
            //     "ผลรวมจำนวนผู้เข้ารับการทดสอบต้องไม่เกินจำนวนพนักงาน",
            //     function (value) {
            //         const { testOccupations = [] } = this.parent || {};
            //         const totalSelected = testOccupations
            //             .flatMap((c) => c?.testTimes || [])
            //             .reduce((sum, cls) => {
            //                 const selected = Number(cls?.testTimeId) > 0;
            //                 const amt = Number(cls?.personAmount || 0);
            //                 return sum + (selected ? amt : 0);
            //             }, 0);
            //         return totalSelected <= Number(value || 0);
            //     }
            // ),

        testOccupations: Yup.array().of(
            Yup.object().shape({
                testTimes: Yup.array().of(
                    Yup.object().shape({
                        testTimeId: Yup.number(),
                        personAmount: Yup.number()
                            .transform((val, orig) =>
                                orig === "" || orig === null ? undefined : val
                            )
                            .when("testTimeId", {
                                is: (v) => Number(v) > 0,
                                then: (schema) =>
                                    schema
                                        .typeError("กรุณากรอกตัวเลข")
                                        .positive("จำนวนคนต้องมีจำนวนมากกว่า 0")
                                        .required("กรุณากรอกจำนวนคน"),
                                otherwise: (schema) => schema.notRequired(),
                            }),
                    })
                ),
            })
        ),
    });

    const detailJobpositionInitialValues = {
        borrowId: searchParams.get("req"),
        registerId: user.registerId,
        id: 0,
        testJobpositionName: "",
        personTotal: "",
        testOccupations: courseSelect.map((test) => ({
            testId: test.testId,
            testTimes: test.listTestTimes.map((time) => ({
                personAmount: "",
                testTimeId: 0
            }))
        }))
    }

    // ------------------------ SUBMIT FOR MODAL -------------------------
    const detailJobpositionOnSubmit = async (values) => {
        let pass = false;
        const { testOccupations } = values;

        await testOccupations.forEach((test) => {
            test.testTimes.forEach((time) => {
                if (time.personAmount !== "") {
                    pass = true;
                    return;
                }
            })
        })

        if (!pass) {
            Swal.fire({
                icon: "warning",
                text: "กรุณาเลือกสาขา / ครั้งทดสอบ อย่างน้อย 1 รายการ",
                confirmButtonColor: rootColorPrimary,
            })
            return;
        }

        Swal.fire({
            icon: "info",
            title: "ยืนยันการบันทึกข้อมูลหรือไม่?",
            confirmButtonColor: rootColorPrimary,
            showCancelButton: true,
            cancelButtonColor: "#d33",
        }).then(async (result) => {
            if (result.isConfirmed) {
                setLoading(true)
                try {
                    let res = await fetch("/api/BorrowRegis/saveTestJobPosition", {
                        method: "POST",
                        headers: { "Content-type": "application/json" },
                        body: JSON.stringify(values)
                    });

                    let resJson = await res.json();
                    if (resJson.status === 1) {
                        Swal.fire({
                            icon: "success",
                            title: "บันทึกข้อมูลสำเร็จ",
                            confirmButtonColor: "#0A66C2",
                        }).then(() => {
                            getTestJobposition()
                            ListTrainTestJobposition()
                            Toggle()
                        })
                    } else {
                        Swal.fire({
                            icon: "error",
                            title: "บันทึกข้อมูลไม่สำเร็จ",
                            text: resJson.message,
                            confirmButtonColor: "#0A66C2",
                        });
                    }
                } catch (e) {
                    console.log(e)
                }
                finally {
                    setLoading(false)
                }
            }
        })
    }

    return (
        <Formik initialValues={initialValues} onSubmit={onSubmit} enableReinitialize>
            {({ values, handleChange, setFieldValue }) => {
                return (
                    <Container className="d-flex flex-column justify-content-center align-items-center mb-5">
                        {!loading ? (
                            <div className="form-border">
                                <Form className="p-5">
                                    <Formik
                                        initialValues={detailJobpositionInitialValues}
                                        validationSchema={detailJobpositionValidationSchema}
                                        onSubmit={detailJobpositionOnSubmit}
                                        enableReinitialize
                                    >
                                        {({ values, handleChange, setFieldValue, resetForm, touched, errors }) => {

                                            async function OnEdit(row) {
                                                resetForm();
                                                setFieldValue("id", row.id)
                                                setFieldValue("testJobpositionName", row.testJobpositionName)
                                                setFieldValue("personTotal", row.personTotal)

                                                await courseSelect.forEach((course, i) => {
                                                    row.testOccupations.forEach((mycourse) => {
                                                        if (course.testId === mycourse.testId) {
                                                            course.listTestTimes.forEach((classItem, index) => {
                                                                mycourse.testTimes.forEach((myClass) => {
                                                                    if (classItem.testTimeId === myClass.testTimeId) {
                                                                        setFieldValue(`testOccupations[${i}].testTimes[${index}].testTimeId`, myClass.testTimeId);
                                                                        setFieldValue(`testOccupations[${i}].testTimes[${index}].personAmount`, myClass.personAmount);
                                                                    }
                                                                })
                                                            })
                                                        }
                                                    })
                                                })
                                                Toggle()
                                            }

                                            async function OnDelete(id) {
                                                Swal.fire({
                                                    icon: "info",
                                                    title: "ยืนยันการลบข้อมูลหรือไม่?",
                                                    confirmButtonColor: rootColorPrimary,
                                                    cancelButtonColor: '#d33',
                                                    showCancelButton: true,
                                                }).then(async (result) => {
                                                    if (result.isConfirmed) {
                                                        let postData = new FormData();
                                                        postData.append("id", id)
                                                        try {
                                                            let res = await fetch("/api/BorrowRegis/deleteTestJobposition", {
                                                                method: "POST",
                                                                body: postData
                                                            });
                                                            let resJson = await res.json();

                                                            if (resJson.status === 1) {
                                                                getTestJobposition()
                                                                ListTrainTestJobposition()
                                                                Swal.fire({
                                                                    icon: "success",
                                                                    title: "ลบข้อมูลสำเร็จ",
                                                                    confirmButtonColor: "#0A66C2",
                                                                }).then(() => window.location.reload());
                                                            } else {
                                                                Swal.fire({
                                                                    icon: "error",
                                                                    title: "ลบข้อมูลไม่สำเร็จ",
                                                                    text: resJson.message,
                                                                    confirmButtonColor: "#0A66C2",
                                                                });
                                                            }

                                                        } catch (e) {
                                                            console.log("err", e)
                                                        }
                                                    }
                                                })
                                            }

                                            const COLUMNS = [
                                                {
                                                    Header: "ลำดับ",
                                                    accessor: (_row, i) => i + 1,
                                                },
                                                {
                                                    Header: "ชื่อตำแหน่งงาน",
                                                    accessor: "testJobpositionName",
                                                },
                                                {
                                                    Header: "จำนวนพนักงาน",
                                                    accessor: "personTotal",
                                                },
                                                {
                                                    Header: "จำนวนผู้เข้ารับการทดสอบฯ",
                                                    accessor: "personAmount",
                                                },
                                                {
                                                    Header: "รายละเอียด",
                                                    accessor: "id",
                                                    Cell: ({ row }) => (
                                                        <div className="text-center">
                                                            <button
                                                                type="button"
                                                                className="btn border border-1 mx-1"
                                                                onClick={() => OnEdit(row.original)}
                                                            >
                                                                <FiEdit3 style={{ color: rootColorPrimary }} />
                                                            </button>
                                                            <button
                                                                type="button"
                                                                className="btn border border-1 mx-1"
                                                                onClick={() => OnDelete(row.original.id)}
                                                            >
                                                                <AiOutlineDelete style={{ color: rootColorErrors }} />
                                                            </button>
                                                        </div>
                                                    ),
                                                },
                                            ];

                                            const AddDetailCourseBtn = () => (
                                                <button type='button' className='btn-green' onClick={() => { resetForm(); Toggle(); }}>
                                                    <BsPlusLg className="mx-2" />
                                                    เพิ่มข้อมูลตำแหน่งของพนักงาน
                                                </button>
                                            );

                                            return (
                                                <>
                                                    <div className="d-flex justify-content-between align-items-center">
                                                        <Label>ข้อมูลตำแหน่งของพนักงานที่เข้ารับการทดสอบฯ</Label>
                                                    </div>

                                                    <Tabs selectedIndex={tabIndex} onSelect={(index) => setTabIndex(index)}>
                                                        <TabList>
                                                            {courseSelect.map((test, i) => (
                                                                <Tab key={i}>สาขาอาชีพ {test.lawOccupationName}</Tab>
                                                            ))}
                                                        </TabList>

                                                        {courseSelect.map((course, index) => (
                                                            <TabPanel key={index}>
                                                                <div className='p-3' style={{ backgroundColor: "#E0F3FF" }}>
                                                                    {course.listTestTimes.map((time) => (
                                                                        <li>
                                                                            ครั้งที่ {time.time} ผู้เข้ารับการทดสอบฯ {time.personAmount} / {time.employeeAmount}
                                                                        </li>
                                                                    ))}
                                                                </div>
                                                            </TabPanel>
                                                        ))}
                                                    </Tabs>

                                                    <div className='mt-2'>
                                                        <CreateTableComponent
                                                            column={COLUMNS}
                                                            dataInput={detailJobPositionDataAr}
                                                            FormInput={AddDetailCourseBtn}
                                                        />
                                                    </div>

                                                    {/* ---------------- MODAL ---------------- */}
                                                    <Modal
                                                        isOpen={openModalForm}
                                                        toggle={Toggle}
                                                        scrollable
                                                        backdrop={'static'}
                                                        keyboard={false}
                                                        centered
                                                        size="lg"
                                                    >
                                                        <ModalHeader toggle={Toggle} className="styled-modal">
                                                            บันทึกข้อมูลตำแหน่งงาน
                                                        </ModalHeader>
                                                        <ModalBody>
                                                            <div className="w-100">
                                                                <Form className="p-4" autoComplete="off">
                                                                    <Field
                                                                        name={`id`}
                                                                        type="hidden"
                                                                        disabled={true}
                                                                    />

                                                                    {/* Job Position Name */}
                                                                    <Label className="me-4 w-100" style={{ lineHeight: "30px" }}>
                                                                        ชื่อตำแหน่งงาน
                                                                        <span className="require-input">*</span>
                                                                        {touched.testJobpositionName && errors.testJobpositionName ? (
                                                                            <span className="text-left text-danger px-1">
                                                                                {errors.testJobpositionName}
                                                                            </span>
                                                                        ) : null}
                                                                    </Label>

                                                                    <Field name={`testJobpositionName`} type="text">
                                                                        {({ field, meta, form }) => (
                                                                            <Input
                                                                                type="text"
                                                                                className={
                                                                                    meta.touched && !form.values.testJobpositionName
                                                                                        ? "input-error rounded-pill text-center input-color cus-type"
                                                                                        : "cus-type rounded-pill text-center input-color"
                                                                                }
                                                                                {...field}
                                                                            />
                                                                        )}
                                                                    </Field>

                                                                    {/* Person Total */}
                                                                    <Label className="me-4 w-100 mt-3" style={{ lineHeight: "30px" }}>
                                                                        จำนวนพนักงาน
                                                                        <span className="require-input">*</span>
                                                                        {touched.personTotal && errors.personTotal ? (
                                                                            <span className="text-left text-danger px-1">
                                                                                {errors.personTotal}
                                                                            </span>
                                                                        ) : null}
                                                                    </Label>

                                                                    <Field name={`personTotal`} type="number">
                                                                        {({ field, meta, form }) => (
                                                                            <Input
                                                                                type="number"
                                                                                className={
                                                                                    meta.touched && !form.values.personTotal
                                                                                        ? "input-error rounded-pill text-center input-color cus-type"
                                                                                        : "cus-type rounded-pill text-center input-color"
                                                                                }
                                                                                {...field}
                                                                            />
                                                                        )}
                                                                    </Field>

                                                                    {/* Select Test Occupation */}
                                                                    <Label className='mt-3'>
                                                                        กรุณาเลือกสาขาอาชีพและครั้งที่ดำเนินการทดสอบฯ
                                                                        <span className="require-input">*</span>
                                                                    </Label>

                                                                    <FieldArray name={`testOccupations`}>
                                                                        {() => (
                                                                            <>
                                                                                {courseSelect?.map((test, i) => (
                                                                                    <div className='mt-3 px-3' key={i}>
                                                                                        <li>
                                                                                            สาขาอาชีพ <span style={{ color: "#0A66C2" }}>{test.lawOccupationName}</span>
                                                                                        </li>

                                                                                        {test.listTestTimes.map((time, index) => (
                                                                                            <div key={index}>
                                                                                                <div className='d-flex align-items-center mt-3'>
                                                                                                    <Field name={`testOccupations[${i}].testTimes[${index}].testTimeId`} type="checkbox">
                                                                                                        {({ field }) => (
                                                                                                            <Input
                                                                                                                type="checkbox"
                                                                                                                className="ms-2 cus-type m-0"
                                                                                                                {...field}
                                                                                                                onChange={(e) => {
                                                                                                                    handleChange(e)
                                                                                                                    if (e.target.checked) {
                                                                                                                        setFieldValue(`testOccupations[${i}].testTimes[${index}].testTimeId`, time.testTimeId);
                                                                                                                    } else {
                                                                                                                        setFieldValue(`testOccupations[${i}].testTimes[${index}].testTimeId`, 0);
                                                                                                                        setFieldValue(`testOccupations[${i}].testTimes[${index}].personAmount`, "");
                                                                                                                    }
                                                                                                                }}
                                                                                                                checked={values.testOccupations[i].testTimes[index].testTimeId !== 0}
                                                                                                            />
                                                                                                        )}
                                                                                                    </Field>

                                                                                                    <span className='ms-2'>
                                                                                                        ครั้งที่ <span style={{ color: "#0A66C2" }}>{time.time}</span>
                                                                                                    </span>

                                                                                                    <span className='ms-2'>
                                                                                                        จำนวนผู้เข้ารับการทดสอบฯ
                                                                                                    </span>

                                                                                                    <Field name={`testOccupations[${i}].testTimes[${index}].personAmount`} type="text">
                                                                                                        {({ field, meta }) => (
                                                                                                            <Input
                                                                                                                type="text"
                                                                                                                className="cus-type rounded-pill input-color w-25 ms-3 text-center"
                                                                                                                disabled={values.testOccupations[i].testTimes[index].testTimeId === 0}
                                                                                                                {...field}
                                                                                                            />
                                                                                                        )}
                                                                                                    </Field>

                                                                                                    <span className='ms-2'>คน</span>
                                                                                                    <ErrorMessage name={`testOccupations[${i}].testTimes[${index}].personAmount`} component={TextErrors} />
                                                                                                </div>
                                                                                            </div>
                                                                                        ))}
                                                                                    </div>
                                                                                ))}
                                                                            </>
                                                                        )}
                                                                    </FieldArray>

                                                                    <hr />

                                                                    <div className='d-flex justify-content-center align-items-center'>
                                                                        <button className='btn-blue w-25' type="submit">
                                                                            บันทึก
                                                                        </button>
                                                                    </div>

                                                                </Form>
                                                            </div>
                                                        </ModalBody>
                                                    </Modal>

                                                    {/* --------- BUTTONS --------- */}
                                                    <div className='d-flex justify-content-between align-items-center mt-5'>
                                                        <button
                                                            onClick={checkPreviousPage}
                                                            type="button"
                                                            className='btn-blue px-4 w-25'
                                                        >
                                                            ย้อนกลับ
                                                        </button>
                                                        <button
                                                            type="submit"
                                                            className='btn-blue px-4 w-25'
                                                            disabled={!cansubmit}
                                                        >
                                                            ส่งคำขอ
                                                        </button>
                                                    </div>
                                                </>
                                            )
                                        }}
                                    </Formik>
                                </Form>

                            </div>

                        ) : (
                            <Loading />
                        )}

                    </Container>
                )
            }}
        </Formik>
    );
}
